import React from "react"
import Img from "../../assets/Album.png"
import "./styles.css"
import { ConfirmationModal } from "../../components/ConfirmationModal"
import { useState } from "react"

function Info(props) {
  const { spotifyLink, youtubeLink, buyLink } = props

  const [displayConfirmationBook, setDisplayConfirmationBook] = useState(false)
  const [displayOverlay, setDisplayOverlay] = useState(false)
  const [displayModal, setDisplayModal] = useState(false)

  function mudarEstadosBook() {
    setDisplayConfirmationBook(true)
    setDisplayOverlay(true)
    setDisplayModal(true)
  }

  function mudarEstadosOverlay() {
    setDisplayModal(!displayModal)
    setDisplayOverlay(!displayOverlay)
  }

  return (
    <div className="container-mobile-livros">
      <div
        className="white-box"
        style={{
          height: "auto",
          marginBottom: "-15px",
          margin: "0 auto",
          boxShadow: "none",
          padding: "0px",
          justifyContent: "center",
          backgroundColor: "transparent",
        }}
      >
        <div className="livros" onClick={() => mudarEstadosBook()}>
          <div className="imagem-container-livros">
            <img
              src={"data:image/jpeg;base64," + props.imagemURL}
              width="95"
              id="base64image"
            />
          </div>
          <div className="textoLivros">
            <p> {props.title} </p>
            <div className="textoArtista">
              <p style={{ color: "#666" }}> {props.address}</p>
            </div>
          </div>
        </div>
      </div>

      {displayModal
        ? displayConfirmationBook && (
            <ConfirmationModal
              buyLink={buyLink}
              setDisplayModal={setDisplayModal}
              displayModal={displayModal}
            />
          )
        : null}

      {displayModal ? (
        <div
          className={`Overlay2 ${displayOverlay ? "Show" : ""}`}
          onClick={() => mudarEstadosOverlay()}
        />
      ) : null}
    
    </div>
  )
}
export default Info
